// extracted by mini-css-extract-plugin
module.exports = {"titleWrap":"InfoModalForm_titleWrap__1F02m","editor":"InfoModalForm_editor__2uxjc","itemEditor":"InfoModalForm_itemEditor__22vJ-"};